import React, { useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import "./SignatureCanvas.css";

const SignaturePad = ({ onSave, onCancel, initialValue = null }) => {
  const sigCanvas = useRef(null);

  useEffect(() => {
    if (initialValue && sigCanvas.current) {
      sigCanvas.current.fromDataURL(initialValue);
    }
  }, [initialValue]);

  const handleClear = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
  };

  const handleSave = () => {
    if (sigCanvas.current) {
      if (sigCanvas.current.isEmpty()) {
        alert("Please provide a signature");
        return;
      }
      const dataUrl = sigCanvas.current.toDataURL();
      onSave(dataUrl);
    }
  };

  return (
    <div className="signature-pad-modal">
      <div className="signature-pad-container">
        <div className="pad-header">
          <h3>Draw Your Signature</h3>
          <button className="close-btn" onClick={onCancel}>
            ×
          </button>
        </div>
        <div className="pad-body">
          <div className="canvas-wrapper">
            <SignatureCanvas
              ref={sigCanvas}
              canvasProps={{
                className: "signature-canvas",
                width: 500,
                height: 200,
              }}
              backgroundColor="#ffffff"
            />
          </div>
          <p className="hint">Sign above</p>
        </div>
        <div className="pad-actions">
          <button className="btn-clear" onClick={handleClear}>
            Clear
          </button>
          <button className="btn-save" onClick={handleSave}>
            Save Signature
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignaturePad;
